import { render } from "./FieldNumber.vue?vue&type=template&id=626cb09a&scoped=true"
import script from "./FieldNumber.vue?vue&type=script&lang=js"
export * from "./FieldNumber.vue?vue&type=script&lang=js"

import "./FieldNumber.vue?vue&type=style&index=0&id=626cb09a&scoped=true&lang=css"

import exportComponent from "/Users/shaohuanqing/dev/kuboard-spray/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-626cb09a"]])

export default __exports__